import PropTypes from 'prop-types';
import React from 'react';
import {
  DEFAULT_BRIGHTNESS,
  DEFAULT_CROP_SCALE,
  DEFAULT_CROP_TOOL_PROPS,
  DEFAULT_IMAGE_CROP,
  DEFAULT_IMAGE_PROPS,
  DEFAULT_STAGE_PROPS,
} from './constants';
import reducer from './reducer';

const initialState = {
  loading: false,
  previewing: false,
  saving: false,
  cropping: false,
  wasCropping: false,
  brightness: DEFAULT_BRIGHTNESS,
  imageCrop: DEFAULT_IMAGE_CROP,
  stageProps: DEFAULT_STAGE_PROPS,
  cropToolProps: DEFAULT_CROP_TOOL_PROPS,
  imageProps: DEFAULT_IMAGE_PROPS,
  cropScale: DEFAULT_CROP_SCALE,
  error: null,
  keepAspectRatio: true,
};

const ImageEditorContext = React.createContext(initialState);

const ImageEditorProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return <ImageEditorContext.Provider value={{ state, dispatch }}>{children}</ImageEditorContext.Provider>;
};

ImageEditorProvider.propTypes = {
  children: PropTypes.any,
};

export { ImageEditorContext, ImageEditorProvider };
